import { forwardRef, type ElementType } from 'react';
import { useClassName } from './useClassName';
import { styleRule } from './styleRule';
import { LooseProps, splitProps } from './props';

export const Stack = forwardRef<HTMLElement, LooseProps>(function Stack(props, ref) {
  const {
    component = 'div',
    sx,
    className,
    children,
    style,
    direction = 'column',
    spacing,
    ...rest
  } = props;
  const { system, dom } = splitProps(rest);
  const {
    className: resolvedClass,
    css,
    styleId,
  } = useClassName(
    sx,
    {
      display: 'flex',
      flexDirection: direction,
      ...(spacing != null
        ? { gap: typeof spacing === 'number' ? `${spacing * 8}px` : spacing }
        : {}),
      ...system,
    },
    className,
  );
  const Tag = component as ElementType;
  return (
    <>
      {styleRule(styleId, css)}
      <Tag {...dom} ref={ref} className={resolvedClass} style={style}>
        {children}
      </Tag>
    </>
  );
});
